export default __webpack_public_path__ + "static/media/wi-strong-wind.fd74a4dd.svg";